var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMainMobile = function SvgMainMobile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-5526.786 -6370.25 21.039 38.869",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .mainMobile-1 {\n        fill: #f0f0f0;\n      }\n\n      .mainMobile-1, .mainMobile-2 {\n        stroke: #585858;\n        stroke-miterlimit: 10;\n        stroke-width: 0.5px;\n      }\n\n      .mainMobile-2 {\n        fill: #fff;\n      }\n\n      .mainMobile-3 {\n        fill: #585858;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "group-76",
    transform: "translate(-5526.536 -6370)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rectangle",
    className: "mainMobile-1",
    width: 20.539,
    height: 38.369,
    rx: 2,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "ellipse",
    className: "mainMobile-2",
    cx: 1.695,
    cy: 1.695,
    rx: 1.695,
    ry: 1.695,
    transform: "translate(8.828 33.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rectangle-2",
    className: "mainMobile-2",
    width: 3.951,
    height: 0.718,
    rx: 0.359,
    transform: "translate(8.293 2.922)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rectangle-3",
    className: "mainMobile-3",
    width: 0.718,
    height: 0.718,
    rx: 0.359,
    transform: "translate(10.627 2.259) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rectangle-4",
    className: "mainMobile-2",
    width: 20.539,
    height: 27.774,
    transform: "translate(0 4.979)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMainMobile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mainMobile.3040c87d.svg";
export { ForwardRef as ReactComponent };